import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { Guid } from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { JobAuditModel } from './job-audit.model';
export const entityName = 'JobHistory';
@Injectable({ providedIn: 'root' })
export class JobAuditDataService extends EfaactDataService<JobAuditModel> {
    mapItems(item: any): JobAuditModel {
        return {
            id: Guid.newGuid(),
            ...item,
            EndTime: moment(item.EndTime).toDate(),
            StartTime: moment(item.StartTime).toDate()
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
